import { createFileRoute } from "@tanstack/react-router";
import type { FoodSensorySessionId } from "@brewbase/db/types";
import { TastingPage } from "@/features/food-sensory/tasting-page";

export const Route = createFileRoute("/food-app/tastings/$tasting_id")({
  component: RouteComponent,
  parseParams: (params) => ({
    tasting_id: parseInt(params.tasting_id, 10),
  }),
  validateSearch: (search: Record<string, unknown>): { step?: string } => ({
    step: typeof search.step === "string" ? search.step : undefined,
  }),
});

function RouteComponent() {
  const { tasting_id } = Route.useParams();
  const { step } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <TastingPage
      key={tasting_id}
      tastingId={tasting_id as FoodSensorySessionId}
      step={step}
      onStep={(next) => navigate({ search: { step: next }, replace: true })}
    />
  );
}
